import { debounce, listener, ListenerTypes } from "../shared";

export const ExitIntent = (() => {
  const onExitIntentHandler = () => {
    listener.emit(ListenerTypes.exitIntent);
  };

  const debouncedOnExitIntentHandler = debounce(onExitIntentHandler, 250);

  const setListener = () => {
    window.addEventListener("blur", debouncedOnExitIntentHandler);

    document.documentElement.addEventListener("mouseleave", (event) => {
      /**
       * Chrome can dispatch mouseleave event when mouse enters the document
       * To filter out this false positive, verify the `y` property is
       * greater than 0
       *
       */
      if (event.y <= 0 || event.clientY <= 0) {
        debouncedOnExitIntentHandler();
      }
    });

    document.documentElement.addEventListener("mousemove", (event) => {
      /**
       * movementY is the mouse acceleration. If it's less than 0,
       * the mouse is moving updwards. Also check if the mouse's Y is
       * is outside the document
       *
       */
      if (event.movementY < 0 && (event.y <= 0 || event.movementY < -event.y)) {
        debouncedOnExitIntentHandler();
      }
    });

    listener.set(ListenerTypes.exitIntent);
  };

  return {
    start: () => {
      setListener();
    },
  };
})();
